<template>
	<div>
		<v-bottom-navigation v-if="!isMobile" class="pagination" background-color="base" flat elevation="0">
			<v-row align="center" class="px-2 py-1">
				<v-col cols="5">
					<v-icon
						v-if="isBroadcaster"
						@click="goToDashboard"
						color="primary"
						size="26"
						class="mr-2 footer-icon">
						{{ icons.mdiCog }}
					</v-icon>
					<v-btn
						depressed
						small
						class="pagination-btn footer-icon mr-1"
						:style="`${!isBroadcaster ? 'margin-left: 32px' : ''}`"
						color="secondary"
						@click="onFirstPage"
						@dblclick="cancelEvent">
						<v-icon color="primary">{{ icons.mdiChevronDoubleLeft }}</v-icon>
					</v-btn>
					<v-btn
						small
						depressed
						class="pagination-btn footer-icon"
						color="secondary"
						@click="onPreviousPage"
						@dblclick="cancelEvent"
						>
						<v-icon color="primary">{{ icons.mdiChevronLeft }}</v-icon>
					</v-btn>
				</v-col>
				<v-col cols="2" class="text-center">
					<span class="primary--text fs--14 fw--600"
						>{{ currentTabData.currentPage + 1 }}/{{ currentTabData.totalPages }}</span
					>
				</v-col>
				<v-col cols="5" class="text-right">
					<v-btn
						small
						depressed
						class="pagination-btn footer-icon mr-1"
						color="secondary"
						@click="onNextPage"
						@dblclick="cancelEvent"
						>
						<v-icon color="primary">{{ icons.mdiChevronRight }}</v-icon>
					</v-btn>
					<v-btn
						depressed
						small
						class="pagination-btn footer-icon"
						color="secondary"
						@click="onLastPage"
						@dblclick="cancelEvent">
						<v-icon color="primary">{{ icons.mdiChevronDoubleRight }}</v-icon>
					</v-btn>
					<v-icon color="primary" size="26" class="ml-2 footer-icon" @click="goToHome">{{
						icons.mdiHeart
					}}</v-icon>
				</v-col>
			</v-row>
		</v-bottom-navigation>
	</div>
</template>

<script>
import { useStore } from '@/store';
import { Links } from '@/utils/constants';
import { getDashboardLink } from '@/utils/config';
import { computed } from 'vue';
import {
	mdiChevronLeft,
	mdiChevronDoubleLeft,
	mdiChevronRight,
	mdiChevronDoubleRight,
	mdiCog,
	mdiHeart,
} from '@mdi/js';

export default {
	name: 'StickersFooter',
	emits: ['onFirstPage', 'onPreviousPage', 'onLastPage', 'onNextPage'],
	props: {
		currentTabData: Object,
	},
	setup(_, { emit }) {
		const store = useStore();

		const isMobile = computed(() => {
			return store.state.isMobile;
		});

		// Determines if the viewer is also the broadcaster.
		const isBroadcaster = computed(() => {
			return store.state.role == 'broadcaster';
		});

		const goToDashboard = () => {
			window.open(getDashboardLink(), '_blank');
		};

		const goToHome = () => {
			window.open(Links.STREAM_STICKERS_HOME, '_blank');
		};

		const onFirstPage = (event) => {
			cancelEvent(event);
			emit('onFirstPage')
		}

		const onNextPage = (event) => {
			cancelEvent(event);
			emit('onNextPage')
		}

		const onLastPage = (event) => {
			cancelEvent(event);
			emit('onLastPage')
		}

		const onPreviousPage = (event) => {
			cancelEvent(event);
			emit('onPreviousPage')
		}

		const cancelEvent = (event) => {
			event.stopImmediatePropagation();
		}

		return {
			isMobile,
			isBroadcaster,
			goToDashboard,
			goToHome,
			onFirstPage,
			onNextPage,
			onLastPage,
			onPreviousPage,
			cancelEvent,
			icons: {
				mdiChevronLeft,
				mdiChevronDoubleLeft,
				mdiChevronRight,
				mdiChevronDoubleRight,
				mdiCog,
				mdiHeart,
			},
		};
	},
};
</script>
